export default __webpack_public_path__ + "assets/wizard-api-864bece0463673fce742aa7689513f6d.svg";